Vue.component('MpModuleContentRating', {
    props: {
        urlOk: String,
        urlKo: String,
        token: String,
        title: String,
        count: String,
        intro: String,
        active: String,
        labelOk: String,
        labelKo: String
    },
    data: function() {
        return {
            VALUE_OK: 'ok',
            VALUE_KO: 'ko',

            userRating: null,
            rating: 0,
            message: '',

            isActive: true,
        };
    },
    computed: {
        dataForm: function() {
            return Serializer.serialize({
                rating: (this.userRating) ? this.VALUE_OK : this.VALUE_KO,
                tk: this.token
            });
        },

        requestURL: function() {
            return (this.userRating) ? this.urlOk : this.urlKo;
        },
    },
    methods: {

        onRating: function(response) {
            if (response.data.result === 'OK') {
                this.rating = response.data.counter;
            } else {
                this.message = response.data.message;
            }
        },

        doRating: function(value) {
            this.userRating = value;

            axios
                .post(this.requestURL, this.dataForm)
                .then(this.onRating)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            this.isActive = Boolean(this.active);
            this.rating = Number(this.count);
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <div class="post-detail__rating">\
        <p class="post-detail__section-title">\
            {{title}}\
            <span class="icon u-va-t">\
                <svg class="icon__inner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.563 5.25l6.75 6.75-6.75 6.75M18.375 12H4.687" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\
            </span>\
            {{rating}}\
        </p>\
\
        <template v-if="isActive">\
            <p class="u-mt-xxs u-mb-0">{{intro}}</p>\
            <p class="post-detail__rating-feedback" v-if="message">{{message}}</p>\
            <div class="row row--compact u-mt-xs">\
                <div class="col-auto">\
                    <a class="btn-ghost" href="#" @click.prevent="doRating(true)">{{labelOk}}</a>\
                </div>\
                <div class="col-auto">\
                    <a class="btn-ghost" href="#" @click.prevent="doRating(false)">{{labelKo}}</a>\
                </div>\
            </div>\
        </template>\
    </div>',
});